<template>
    <div class="page">
        <div class="contact-info-container">
            <h1>Ota yhteyttä</h1>
            <p>Voit varata ajan sähköisesti <router-link to="/varaa">täältä</router-link>. Jos et löydä itsellesi sopivaa aikaa, ota rohkeasti yhteyttä.</p>
            <p id="contact">
                Sähköposti: <a href="mailto:koliklinikka@gmail.com">koliklinikka@gmail.com</a><br />
                Puhelin: 045 78344 559
            </p>
            <br />
            <h1>Vastaanotot:</h1>
            <h2>Terveys 57</h2>
            <p>
                Laurinkatu 57 c/o Terveys 57, 08100 Lohja
            </p>
            <a href="https://www.google.com/maps?q=Laurinkatu+57,+Lohja"
               target="_blank"
               rel="noopener noreferrer">
                <p class="map-link">Näytä kartalla</p>
            </a>
            <h2>Viherin Fiilis</h2>
            <p>
                Viherlaaksontie 5, 02710 Espoo
            </p>
            <a href="https://www.google.com/maps?q=Viherlaaksontie+5,+Espoo"
               target="_blank"
               rel="noopener noreferrer">
                <p class="map-link">Näytä kartalla</p>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContactPage'
    };
</script>

<style scoped>
    .contact-info-container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
    }

    p {
        text-align: center;
    }

    a {
        text-decoration: none;
        font-size: calc(0.9rem + 0.3vw);
        font-weight: bold;
        transition: color 0.3s;
        color: #374a40;
    }

        a:hover {
            text-decoration: underline;
        }

    .map-link {
        padding-bottom: 1rem;
    }

    #contact {
        font-weight: bold;
    }
</style>
